<div class="hero_area2">
    <app-menu></app-menu>
    <!-- <app-carrossel [config]="config"></app-carrossel> -->
</div>
<app-produto-detalhe-body [config]="config"></app-produto-detalhe-body>

